import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIProgress from 'UIComponents/progress/UIProgress';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { UsageLimitToI18nKey } from 'pricing-pages-lib/constants/UsageLimitToI18nKey';
import { useAppSelector } from '../../reducers';
import { getFeatureWithDefaultsSelector } from '../../selectors/FeatureSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const LimitUsageFeatureRow = props => {
  const {
    limit,
    usage,
    limitName
  } = props.limitUsage;
  const {
    name,
    nextTierLimit
  } = UsageLimitToI18nKey[limitName];
  const feature = useAppSelector(state => getFeatureWithDefaultsSelector(state, {
    shortName: name
  }));
  if (!feature) return null;
  const featureName = feature.displayName.toLocaleLowerCase();
  const percentageOfUsageLimitUsed = typeof usage === 'number' && typeof limit === 'number' && limit !== 0 ? usage / limit * 100 : 0;
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "left",
    title: feature.description,
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIProgress, {
        value: percentageOfUsageLimitUsed,
        descriptiveLabel: /*#__PURE__*/_jsx("b", {
          style: {
            fontSize: '14px'
          },
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "ebxInterstitialPage.LimitUsageSection.featureLimit.title",
            options: {
              featureName,
              usage,
              limit
            }
          })
        }),
        valueLabel: /*#__PURE__*/_jsx("span", {
          style: {
            fontWeight: 400,
            fontSize: '14px'
          },
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "ebxInterstitialPage.LimitUsageSection.featureLimit.subtitle",
            options: {
              featureName,
              newLimit: nextTierLimit
            }
          })
        })
      })
    })
  });
};
export default LimitUsageFeatureRow;